import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { ManageEquipmentService } from '../manage-equipment.service';
import { ChartLegendPreference, EquipmentCompartmentTypeModel, EquipmentCompartTypePreferenceRequest, EquipmentComponentWearModel } from '../models/manage-equipment.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShovelGraphTablePopupComponent } from './shovel-graph-table-popup/shovel-graph-table-popup.component';
import { forkJoin, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-shovel-graph',
  templateUrl: './shovel-graph.component.html',
  styleUrls: ['./shovel-graph.component.scss']
})
export class ShovelGraphComponent implements OnInit {
  @Input() equipmentId!: number;
  EquipmentComponentWearModel: EquipmentComponentWearModel[] = [];
  isPopup: boolean = false;
  chartConfigs: any[] = [];
  isLoading = true;
  EquipmentCompartmentTypeModel: EquipmentCompartmentTypeModel[] = [];
  constructor(private _equipmentService: ManageEquipmentService, private dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ShovelGraphComponent>) { }

  ngOnInit(): void {
    if (this.data?.equipmentId != null) {
      this.equipmentId = this.data.equipmentId;
      this.isPopup = this.data.IsPopup;
    }
    this.GetShovelMethod();

    this.getEquipmentCompartTypes();
  }
  onCompartTypeSelectionChange(): void {

  }
  isCompartTypeVisible(compartTypeId: number): boolean {

    const compart = this.EquipmentCompartmentTypeModel?.find(
      x => x.CompartTypeId === compartTypeId
    );

    return compart ? compart.IsShovel : true;
  }
  getEquipmentCompartTypes(): void {
    this._equipmentService
      .GetEquipmentCompartmentTypes(this.equipmentId)
      .subscribe({
        next: (res: EquipmentCompartmentTypeModel[]) => {
          this.EquipmentCompartmentTypeModel = res;
        },
        error: (error) => {
          console.error(
            'Error loading equipment compartment types',
            error
          );
        }
      });
  }

  // loadShovelGraph() {

  //   this._equipmentService
  //     .GetGraphdataForShovels(this.equipmentId)
  //     .subscribe(equipment => {
  //       this.EquipmentComponentWearModel = equipment;
  //       const commonInterval =
  //         this.getCommonChartInterval(equipment);
  //       this.chartConfigs = equipment.map((item: any) => ({
  //         compartTypeId: item.CompartTypeId,
  //         compartType: item.CompartType,
  //         dataSource: JSON.parse(JSON.stringify(this.buildChart(item, commonInterval))),

  //         tableData: [...(item.Data ?? [])].sort((a: any, b: any) => {

  //           const sideA = a.Compart?.startsWith("LH") ? 0 : 1;

  //           const sideB = b.Compart?.startsWith("LH") ? 0 : 1;


  //           if (sideA !== sideB) {
  //             return (sideA - sideB);
  //           }

  //           return (
  //             Number(a.SMU) -
  //             Number(b.SMU)
  //           );

  //         }
  //         )

  //       })
  //       );
  //     });

  // }
  measurementDisplayType: number = 1;

  onMeasurementDisplayTypeChange(type: number): void {
    this.measurementDisplayType = type;

    this._equipmentService.ShovelMethod(type).subscribe({
      next: (result: boolean) => {
        if (result) {
          this.loadShovelGraph();
        }
      },
      error: (error) => {
        console.error('Error saving shovel method:', error);
      }
    });

    if (type === 1) {
      this.loadShovelGraph();
    } else if (type === 2) {
      this.loadShovelGraph();
    }
  }
  GetShovelMethod() {
    this._equipmentService.GETShovelMethod().subscribe({
      next: (result: number) => {


        this.measurementDisplayType = result == 0 ? 1 : result;
        this.loadShovelGraph();

      },
      error: (error) => {
        console.error('Error saving shovel method:', error);
      }
    });
  }
  loadShovelGraph(): void {
    this.isLoading = true;
    this.chartConfigs = [];
    this._equipmentService
      .GetGraphdataForShovels(this.equipmentId, this.measurementDisplayType)
      .subscribe({
        next: (equipment: any[]) => {
          this.EquipmentComponentWearModel = equipment;
          const commonInterval = this.getCommonChartInterval(equipment);
          const compartTypeIds = [...new Set((equipment ?? []).map((item: any) => Number(item.CompartTypeId))
            .filter((id: number) => Number.isFinite(id))
          )];
          if (compartTypeIds.length === 0) {
            this.chartLegendPreferences.clear();
            this.buildShovelChartConfigs(equipment, commonInterval);
            return;
          }
          const preferenceRequests = compartTypeIds.map((compartTypeId: number) =>
            this._equipmentService.getChartLegendPreferences(compartTypeId, this.equipmentId)
              .pipe(
                catchError((error) => {
                  console.error(
                    `Error loading legend preferences for CompartType ${compartTypeId}:`,
                    error
                  );

                  return [[] as ChartLegendPreference[]];
                })
              )
          );

          forkJoin(preferenceRequests).subscribe({
            next: (
              preferencesByCompartType:
                ChartLegendPreference[][]
            ) => {
              this.chartLegendPreferences.clear();
              preferencesByCompartType.forEach((preferences: ChartLegendPreference[], index: number) => {
                const compartTypeId = compartTypeIds[index];
                (preferences ?? []).forEach((preference: ChartLegendPreference) => {
                  const key = this.getLegendPreferenceKey(compartTypeId, preference.Component, preference.GraphType);
                  this.chartLegendPreferences.set(key, preference.IsVisible);
                }
                );
              }
              );
              this.buildShovelChartConfigs(equipment, commonInterval);
              this.isLoading = false;
            },
            error: (error) => {
              console.error(
                "Error loading chart legend preferences:",
                error
              );
              this.chartLegendPreferences.clear();
              this.buildShovelChartConfigs(equipment, commonInterval);
              this.isLoading = false;
            }
          });
        },
        error: (error) => {
          console.error("Error loading shovel graph data:", error);
          this.isLoading = false;
        }
      });
  }
  private buildShovelChartConfigs(equipment: any[], commonInterval: number): void {

    this.chartConfigs = (equipment ?? []).map((item: any) => ({

      compartTypeId: item.CompartTypeId,

      compartType: item.CompartType,

      // renderKey is incremented on each legend toggle to force Angular to
      // destroy and recreate the FusionCharts component, which is the only
      // way FusionCharts 3.x applies `initiallyhidden` on an existing chart.
      renderKey: 0,

      dataSource: JSON.parse(JSON.stringify(this.buildChart(item, commonInterval))),

      tableData: [...(item.Data ?? [])].sort((a: any, b: any) => {
        // Remove LH / RH for component comparison
        const componentA = (a.Compart ?? '')
          .replace(/^(LH|RH)\s*-\s*/i, '')
          .trim();
      
        const componentB = (b.Compart ?? '')
          .replace(/^(LH|RH)\s*-\s*/i, '')
          .trim();
      
        // 1. Component / Position
        const componentCompare = componentA.localeCompare(
          componentB,
          undefined,
          {
            numeric: true,
            sensitivity: 'base'
          }
        );
      
        if (componentCompare !== 0) {
          return componentCompare;
        }
      
        // 2. SMU
        const smuA = Number(a.SMU ?? 0);
        const smuB = Number(b.SMU ?? 0);
      
        if (smuA !== smuB) {
          return smuA - smuB;
        }
      
        // 3. LH before RH
        const sideA = (a.Side ?? '').toUpperCase();
        const sideB = (b.Side ?? '').toUpperCase();
      
        if (sideA === 'LH' && sideB === 'RH') {
          return -1;
        }
      
        if (sideA === 'RH' && sideB === 'LH') {
          return 1;
        }
      
        return 0;
      })
      
      
    }));
  }
  private getCommonChartInterval(equipment: any[]): number {
    const allSMUValues: number[] = [];
    (equipment ?? []).forEach((item: any) => {
      const data = item.Data ?? [];
      data.forEach((point: any) => {
        const smu = Number(point.SMU);
        if (Number.isFinite(smu)) {
          allSMUValues.push(smu);
        }
      }
      );
      const budgetLife = Number(item.BudgetLife ?? 0);
      if (budgetLife > 0 && data.length > 0) {
        const sortedData = [...data]
          .filter((x: any) => x.SMU != null && Number.isFinite(Number(x.SMU)))
          .sort((a: any, b: any
          ) => Number(a.SMU) - Number(b.SMU));
        if (sortedData.length > 0) {
          const startingSMU = Number(sortedData[0].SMU);
          const budgetEndSMU = startingSMU + budgetLife;
          if (Number.isFinite(budgetEndSMU)
          ) {
            allSMUValues.push(budgetEndSMU);
          }
        }
      }
    }
    );
    if (allSMUValues.length === 0) {
      return 2000;
    }
    const globalMin = Math.min(...allSMUValues);


    const globalMax = Math.max(...allSMUValues);

    const interval = this.getNiceInterval(globalMin, globalMax);
    return interval;

  }
  buildChart(item: any, commonInterval: number): any {

    const budgetLife = Number(item.BudgetLife ?? 0);

    const smuValues = (item.Data ?? []).map((x: any) => Number(x.SMU)).filter((x: number) => Number.isFinite(x));
    if (smuValues.length === 0) {
      return null;
    }

    const sortedSMUData = [...(item.Data ?? [])].filter((x: any) => x.SMU != null && Number.isFinite(Number(x.SMU)))
      .sort((a: any, b: any) => Number(a.SMU) - Number(b.SMU));

    const startingSMU = Number(sortedSMUData[0]?.SMU ?? Math.min(...smuValues));

    const budgetEndSMU = budgetLife > 0 ? startingSMU + budgetLife : startingSMU;

    const maxSMU = Math.max(...smuValues, budgetEndSMU);

    const interval = commonInterval > 0 ? commonInterval : 2000;

    const chartMin = Math.floor(startingSMU / interval) * interval;

    const chartMax = Math.ceil(maxSMU / interval) * interval;

    const axisCategories: any[] = [];

    let isFirstCategory = true;

    for (let smu = chartMin; smu <= chartMax; smu += interval) {


      const cmu = Math.max(0, smu - startingSMU);

      const formattedCMU = cmu.toLocaleString("en-US");
      const formattedSMU = smu.toLocaleString("en-US");

      let label: string;

      if (isFirstCategory) {
        label = `CMU ${formattedCMU}\n` + `SMU ${formattedSMU}`;
        isFirstCategory = false;
      } else {

        label = `${formattedCMU}\n` + `${formattedSMU}`;
      }

      axisCategories.push({
        x: smu,
        label: label,
        showLabel: "1",
        showVerticalLine: "1"
      });
    }


    const graph =
      this.getSeries(item.Data ?? [], startingSMU, Number(item.CompartTypeId), "ShovelGraph");

    const series =
      graph.series;


    if (budgetLife > 0) {

      series.push({
        seriesname: "Budget Life",
        showInLegend: "1",
        includeInLegend: "1",
        color: "#000000",
        drawLines: "0",
        drawAnchors: "0",
        anchorAlpha: "0",
        alpha: "100",
        data: [
          {
            x: budgetEndSMU,
            y: 105,
            showValue: "1",
            displayValue: "Budget Life",
            valuePosition: "ABOVE",
            anchorAlpha: "0",
            anchorRadius: "0",
            toolText:
              "<b>Budget Life</b>" +
              "<br/>SMU : " +
              budgetEndSMU
          }
        ]
      });
    }

    return {

      chart: {

        caption: item.CompartType,
        theme: "fusion",
        creditLabel: false,
        xAxisName: "SMU",
        xAxisMinValue: chartMin,
        xAxisMaxValue: chartMax,
        xAxisLabelMode: "CATEGORIES",
        showXAxisValues: "1",
        showVLimits: "1",
        showVDivLineValues: "1",
        labelStep: "1",
        xAxisValuesStep: "1",
        labelDisplay: "NORMAL",
        rotateLabels: "0",
        slantLabels: "0",
        staggerLines: "1",
        useEllipsesWhenOverflow: "0",
        yAxisName: "Wear %",
        numberSuffix: "%",
        numDivLines: "10",
        showYAxisValues: "1",
        showLimits: "1",
        yAxisMaxValue: "110",
        drawLines: "1",
        drawAnchors: "1",
        lineThickness: "2",
        anchorRadius: "5",
        anchorBgColor: "#ffffff",
        anchorBorderThickness: "2",
        anchorHoverRadius: "7",
        showValues: "0",
        showHoverEffect: "1",
        labelFontBold: "1",
        connectNullData: "1",
        showLegend: "1",
        legendPosition: "top",
        legenditemfontsize: "15",
        legenditemfontbold: "1",
        adjustVDiv: "1",
        numVDivLines: "9",
        vDivLineColor: "#D9D9D9",
        vDivLineThickness: "1",
        vDivlineAlpha: "100",
        vDivLineDashed: "0",
        divLineColor: "#E5E5E5",
        divLineAlpha: "60",
        divLineThickness: "1",
        showAlternateVGridColor: "0",
        showVZeroPlane: "0"
      },

      categories: [
        {
          category: axisCategories
        }
      ],

      dataset: series,


      trendlines: [
        {
          line: [
            {
              startvalue: "100",
              color: "#FF0000",
              thickness: "2",
              dashed: "0",
              displayvalue: "100% Wear",
              valueOnRight: "1"
            }
          ]
        }
      ],


      vTrendlines:
        budgetLife > 0
          ? [
            {
              line: [
                {
                  startValue: budgetEndSMU,
                  color: "#000000",
                  alpha: "100",
                  thickness: "2",
                  dashed: "1",
                  dashLen: "5",
                  dashGap: "5",
                  showOnTop: "1"
                }
              ]
            }
          ]
          : []
    };
  }



  getSeries(data: any[], budgetStartSMU?: number, compartTypeId?: number, graphType?: string) {
    const colors = [
      "#1F77B4", // Blue
      "#FF7F0E", // Orange
      "#2CA02C", // Green
      "#D62728", // Red
      "#9467BD", // Purple
      "#8C564B", // Brown
      "#E377C2", // Pink
      "#17BECF", // Cyan
      "#BCBD22", // Olive
      "#7F7F7F", // Gray
      "#004C6D", // Dark Blue
      "#E66101", // Dark Orange
      "#238B45", // Dark Green
      "#B2182B", // Dark Red
      "#6A3D9A", // Dark Purple
      "#A65628", // Dark Brown
      "#C51B8A", // Magenta
      "#008C95", // Teal
      "#8C8C00", // Dark Olive
      "#404040"  // Dark Gray
    ];
    const grouped = data.reduce((acc: any, curr: any) => {

      if (!acc[curr.Compart]) {
        acc[curr.Compart] = [];
      }
      acc[curr.Compart].push(curr);
      return acc;
    },
      {}
    );
    const orderedSeries =
      Object.keys(grouped).sort((a: string, b: string) => {

        const getOrder = (name: string) => {
          if (name.startsWith("LH")) {
            return 1;
          }
          if (name.startsWith("RH")) {
            return 2;
          }

          return 3;
        };

        const order = getOrder(a) - getOrder(b);

        return order !== 0 ? order : a.localeCompare(b);
      }
      );
    const series: any[] = [];
    orderedSeries.forEach(
      (
        compart: string, index: number
      ) => {
        const color = colors[index % colors.length];


        const points =
          [...grouped[compart]]
            .filter((x: any) => x.SMU != null && Number.isFinite(Number(x.SMU)))
            .sort((a: any, b: any) => Number(a.SMU) - Number(b.SMU));
        if (!points.length) {
          return;
        }
        const actualData = points.map((point: any) => {
          const smu = Number(point.SMU);
          const wear = point.WornPercentage == null ? null : Number(point.WornPercentage);
          return {
            x: smu,
            y: wear,
            toolText: "<b>" + compart + "</b>" + "<br/>SMU : " + smu + "<br/>Hours : " +
              (
                point.HoursOnSurface ??
                ""
              ) +
              "<br/>Wear : " + wear + "%" + "<br/>InspectionDate : " + this.formatDate(point.InspectionDate)
          };
        }
        );

        let isVisible = true;
        if (compartTypeId != null && graphType) {
          const preferenceKey =
            this.getLegendPreferenceKey(compartTypeId, compart, graphType);
          const savedVisibility = this.chartLegendPreferences.get(preferenceKey);
          if (savedVisibility !== undefined) {
            isVisible = savedVisibility;
          }
        }
        series.push({
          seriesname: compart,
          color: color,
          initiallyhidden: isVisible ? "0" : "1",
          showInLegend: "1",
          includeInLegend: "1",
          drawLines: "1",
          lineThickness: "2",
          lineAlpha: "100",
          drawAnchors: "1",
          anchorRadius: "5",
          anchorBgColor: "#ffffff",
          anchorBorderColor: color,
          anchorBorderThickness: "2",
          anchorAlpha: "100",
          anchorHoverRadius: "7",
          data: actualData
        });
        const componentBudgetLife = Number(points[0].ComponentBudgetLife);

        if (!Number.isFinite(componentBudgetLife) || componentBudgetLife <= 0
        ) { return; }
        const startSMU = Number(points[0].SMU);
        const startWear = points[0].WornPercentage == null ? 0 : Number(points[0].WornPercentage);
        const budgetBaseSMU = Number.isFinite(Number(budgetStartSMU)) ? Number(budgetStartSMU) : startSMU;
        const budgetEndSMU = budgetBaseSMU + componentBudgetLife;
        const forecastData = [
          { x: startSMU, y: startWear },
          { x: budgetEndSMU, y: 100 }
        ];

        series.push({
          seriesname: compart,
          showInLegend: "0",
          includeInLegend: "0",
          color: color,
          initiallyhidden: isVisible ? "0" : "1",
          drawLines: "1",
          dashed: "1",
          dashLen: "5",
          dashGap: "4",
          lineThickness: "2",
          lineAlpha: "100",
          drawAnchors: "0",
          anchorAlpha: "0",
          showValues: "0",
          data: forecastData
        });
      }
    );
    return { series: series };
  }

  trackByCompart(index: number, item: any) {
    return `${item.compartTypeId}_${item.renderKey ?? 0}`;
  }

  private getNiceInterval(min: number, max: number): number {
    const range = max - min;
    if (range <= 10000) return 1000;
    if (range <= 20000) return 2000;
    if (range <= 50000) return 3000;
    if (range <= 80000) return 5000;
    if (range <= 100000) return 10000;
    const magnitude = Math.pow(10, Math.floor(Math.log10(range / 6)));
    const residual = (range / 6) / magnitude;
    if (residual <= 1) return magnitude;
    if (residual <= 2) return 2 * magnitude;
    if (residual <= 5) return 5 * magnitude;
    return 10 * magnitude;
  }

  openTablePopup(chart: any) {
    console.log('Opening table popup for chart:', chart);
    this.dialog.open(ShovelGraphTablePopupComponent, {
      width: '900px',
      maxHeight: '80vh',
      data: {
        title: chart.compartType,
        tableData: chart.tableData
      }

    });
  }
  onNoClick() {
    this.dialogRef.close();
  }
  formatDate(value: any): string {
    if (!value)
      return '';
    const d = new Date(value);
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  formatMonth(value: any): string {
    if (!value)
      return '';

    const d = new Date(value);
    return d.toLocaleDateString('en-GB', {
      month: 'short',
      year: 'numeric'
    });
  }

  onLegendItemClicked(event: any, chart: any): void {
    const data = event?.dataObj;

    if (!data) {
      return;
    }

    const component =
      data?.datasetName ||
      data?.seriesName ||
      data?.categoryLabel;

    if (!component) {
      return;
    }

    const preferenceKey = this.getLegendPreferenceKey(
      Number(chart.compartTypeId),
      component,
      "ShovelGraph"
    );

    const currentVisibility =
      this.chartLegendPreferences.get(preferenceKey);

    const isVisible =
      currentVisibility === undefined
        ? false
        : !currentVisibility;

    this.chartLegendPreferences.set(
      preferenceKey,
      isVisible
    );

    const request = {
      Compart_type_auto: chart.compartTypeId,
      Component: component,
      GraphType: "ShovelGraph",
      IsVisible: isVisible,
      EquipmentId: this.equipmentId
    };

    this._equipmentService.SaveChartLegendPreference(request).subscribe({
      next: () => {
      },
      error: (error) => {
        console.error("Error saving legend preference:", error);
      }
    });

    this.rebindShovelCharts();
  }
  private rebindShovelCharts(): void {
    const equipment = this.EquipmentComponentWearModel;

    if (!equipment || equipment.length === 0) {
      return;
    }

    const commonInterval = this.getCommonChartInterval(equipment);

    this.chartConfigs = [];

    setTimeout(() => {
      requestAnimationFrame(() => {
        this.chartConfigs = equipment.map((item: any) => ({
          compartTypeId: item.CompartTypeId,
          compartType: item.CompartType,
          renderKey: `${item.CompartTypeId}_${Date.now()}_${Math.random()}`,
          dataSource: JSON.parse(
            JSON.stringify(
              this.buildChart(
                item,
                commonInterval
              )
            )
          ),
          tableData: [...(item.Data ?? [])].sort((a: any, b: any) => {
            // Remove LH / RH for component comparison
            const componentA = (a.Compart ?? '')
              .replace(/^(LH|RH)\s*-\s*/i, '')
              .trim();
          
            const componentB = (b.Compart ?? '')
              .replace(/^(LH|RH)\s*-\s*/i, '')
              .trim();
          
            // 1. Component / Position
            const componentCompare = componentA.localeCompare(
              componentB,
              undefined,
              {
                numeric: true,
                sensitivity: 'base'
              }
            );
          
            if (componentCompare !== 0) {
              return componentCompare;
            }
          
            // 2. SMU
            const smuA = Number(a.SMU ?? 0);
            const smuB = Number(b.SMU ?? 0);
          
            if (smuA !== smuB) {
              return smuA - smuB;
            }
          
            // 3. LH before RH
            const sideA = (a.Side ?? '').toUpperCase();
            const sideB = (b.Side ?? '').toUpperCase();
          
            if (sideA === 'LH' && sideB === 'RH') {
              return -1;
            }
          
            if (sideA === 'RH' && sideB === 'LH') {
              return 1;
            }
          
            return 0;
          })
          
          
          
        }));

        requestAnimationFrame(() => {
          window.dispatchEvent(new Event("resize"));
        });
      });
    }, 100);
  }


  private chartLegendPreferences = new Map<string, boolean>();
  private getLegendPreferenceKey(compartTypeAuto: number, component: string, graphType: string
  ): string {
    return `${compartTypeAuto}_${component}_${graphType}`;
  }
  onCompartTypeChange(item: EquipmentCompartmentTypeModel): void {
    const request: EquipmentCompartTypePreferenceRequest = {
      EquipmentId_Auto: this.equipmentId,
      CompartTypeId: item.CompartTypeId,
      IsSelected: item.IsShovel
    };
    this._equipmentService.SaveEquipmentCompartTypePreference(request)
      .subscribe({
        next: () => {
          console.log('Preference saved successfully');
        },
        error: (error) => {

          console.error(
            'Error saving compartment type preference',
            error
          );
          item.IsSelected = !item.IsSelected;
        }
      });
  }
}
